import Reveal from "./Reveal";

export default function Testimonial({ t }) {
  return (
    <section
      data-testid="testimonial-section"
      className="py-28 md:py-40 bg-[#3E362E] text-[#FDFBF7] relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -left-20 -bottom-40 font-chinese text-[30rem] leading-none text-white/5 select-none pointer-events-none hidden md:block"
      >
        源
      </div>

      <div className="relative max-w-4xl mx-auto px-6 md:px-10 text-center">
        <Reveal>
          <span className="overline !text-[#D0B8A8]">{t.testimonial.overline}</span>
        </Reveal>

        <Reveal delay={150}>
          <p
            className="testimonial-quote text-2xl md:text-4xl leading-[1.3] mt-10 text-[#F5EFE6]"
            data-testid="testimonial-quote"
          >
            {t.testimonial.quote}
          </p>
        </Reveal>

        <Reveal delay={300}>
          <div className="mt-12 flex items-center justify-center gap-3">
            <span className="h-px w-12 bg-[#1A9BC1]" />
            <span className="font-serif text-xl italic">{t.testimonial.author}</span>
            <span className="divider-dot !bg-[#D0B8A8]" />
            <span className="text-sm tracking-widest uppercase text-[#D0B8A8]">
              {t.testimonial.location}
            </span>
            <span className="h-px w-12 bg-[#1A9BC1]" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
